import "./baseConfig/font.css.ts.vanilla.mjs";
import "./radioGroup.css.ts.vanilla.mjs";
var p = "p273__radioGroup-0793_fca54f1__1bvqcjd0";
export {
  p as radioGroupStyle
};
//# sourceMappingURL=radioGroup.mjs.map
